/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatPngIcon16Light } from './FileFormatPngIcon16Light';
import { FileFormatPngIcon16Regular } from './FileFormatPngIcon16Regular';
import { FileFormatPngIcon16Solid } from './FileFormatPngIcon16Solid';
import { FileFormatPngIcon20Light } from './FileFormatPngIcon20Light';
import { FileFormatPngIcon20Regular } from './FileFormatPngIcon20Regular';
import { FileFormatPngIcon20Solid } from './FileFormatPngIcon20Solid';
import { FileFormatPngIcon24Regular } from './FileFormatPngIcon24Regular';
import { FileFormatPngIcon24Solid } from './FileFormatPngIcon24Solid';
import { FileFormatPngIcon32Regular } from './FileFormatPngIcon32Regular';
import { FileFormatPngIcon64Regular } from './FileFormatPngIcon64Regular';
var sizes = {
    16: {
        light: FileFormatPngIcon16Light,
        regular: FileFormatPngIcon16Regular,
        solid: FileFormatPngIcon16Solid,
    },
    20: {
        light: FileFormatPngIcon20Light,
        regular: FileFormatPngIcon20Regular,
        solid: FileFormatPngIcon20Solid,
    },
    24: {
        regular: FileFormatPngIcon24Regular,
        solid: FileFormatPngIcon24Solid,
    },
    32: {
        regular: FileFormatPngIcon32Regular,
    },
    64: {
        regular: FileFormatPngIcon64Regular,
    },
};
export var FileFormatPngIcon = forwardRef('FileFormatPngIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
